import { LoadingState, SectionHeader } from '../../../shared/components/index.js';
import { useLeadsData } from '../hooks/useLeadsData.jsx';
import HtmlBlock from '../components/HtmlBlock.jsx';
import { buildCohortHtml, buildFinalsHtml } from '../utils/present-leads-html.js';

export default function LeadsConversionPage() {
  const { loading, data } = useLeadsData();
  if (loading && !data) return <LoadingState />;
  return (
    <div className="analytics-grid-2">
      <section className="analytics-section">
        <SectionHeader
          title="Cohorte del período"
          note="Historia del ingreso en el período · no confundir con el stock abierto actual."
        />
        <HtmlBlock html={buildCohortHtml(data && data.cohort)} className="analytics-panel" />
      </section>
      <section className="analytics-section">
        <SectionHeader
          title="Resultados finales"
          note="Distribución de cierres asociados al período · % sobre la cohorte ingresada."
        />
        <HtmlBlock
          html={buildFinalsHtml(data && data.finals, data && data.cohort)}
          className="analytics-panel"
        />
      </section>
    </div>
  );
}
